"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextArea = exports.LargeTextInputWrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * A styled wrapper for the `StyledTextArea` component.
 *
 * @example
 * ```tsx
 * <LargeTextInputWrapper>
 *   <StyledTextArea placeholder="Enter text here..." />
 * </LargeTextInputWrapper>
 * ```
 */
exports.LargeTextInputWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n"], ["\n  margin-bottom: 1rem;\n"])));
/**
 * A styled textarea component.
 *
 * @example
 * ```tsx
 * <StyledTextArea
 *    placeholder="Enter text here..."
 *    value={inputValue}
 *    onChange={(e) => setInputValue(e.target.value)}
 *  />
 * ```
 */
exports.StyledTextArea = styled_components_1.default.textarea(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 10rem;\n  padding: 0.5rem;\n  font-size: ", ";\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  resize: vertical;\n  transition: border 0.2s;\n  \n  &:focus {\n    outline: none;\n    border: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  height: 10rem;\n  padding: 0.5rem;\n  font-size: ", ";\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  resize: vertical;\n  transition: border 0.2s;\n  \n  &:focus {\n    outline: none;\n    border: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.fontSize; }, function (props) { return props.theme.color; }, function (props) { return props.theme.white; }, function (props) { return props.theme.border; }, function (props) { return props.theme.borderRadius; }, function (props) { return props.theme.borderFocused; }, function (props) { return props.theme.grey; });
var templateObject_1, templateObject_2;
